"use client";

import { AppPageTitle } from "@/widgets";
import MatterSection from "@/widgets/app/page/weslo/MattersSection";
import OverViewSection from "@/widgets/app/page/weslo/OverViewSection";
import ProgramSection from "@/widgets/app/page/weslo/ProgramSection";
import WesloInfoSection from "@/widgets/app/page/weslo/WesloInfoSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function WesloPage() {
  return (
    <SsgoiTransition id="/app/pages/weslo">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        {/* 타이틀 */}
        <WesloInfoSection />
        {/* 오버뷰 */}
        <OverViewSection />
        {/* 문제 */}
        <MatterSection />
        {/* 프로그램 */}
        <ProgramSection />
      </div>
    </SsgoiTransition>
  );
}
